import { useEffect, useState } from 'react'
import snowflakeSvg1 from './blue-bold.svg'
import snowflakeSvg2 from './blue-light.svg'
// import snowflakeSvg3 from './Snowflake Icon.svg'
import Snowfall from 'react-snowfall'

export const Snow = () => {
  const [snowflakes, setSnowflakes] = useState<HTMLImageElement[]>([])

  useEffect(() => {
    const img1 = document.createElement('img')
    img1.onload = () => setSnowflakes(prev => [...prev, img1])
    img1.onerror = () => setSnowflakes([])
    img1.src = snowflakeSvg1.src

    const img2 = document.createElement('img')
    img2.onload = () => setSnowflakes(prev => [...prev, img2])
    img2.onerror = () => setSnowflakes([])
    img2.src = snowflakeSvg2.src
  }, [])

  if (!snowflakes.length) {
    return null
  }

  return <Snowfall radius={[2, 12]} images={snowflakes} />
}
